import React, { useContext } from 'react';
import { Context } from '../..'; 
import AccessDenied from '../AccessDenied/AccessDenied';

const AccessRouter = ({ component: Component, isProtected, path, requireAccess, ...rest }) => {
  const { user } = useContext(Context);

  const hasAccess = () => {
    if (!user.access) return false;
    if (user.isOwner) return true;
    
    // Если указаны конкретные требования доступа, проверяем их
    if (requireAccess && requireAccess.length > 0) {
      return requireAccess.every(accessKey => user.access[accessKey] === true);
    }
    
    // Старая логика для обратной совместимости
    const accessMap = {
      '/chats': user.access.chat,
      '/chats/settings': user.access.manageChatCategories,
      '/news': user.access.news,
      '/news/:id': user.access.news,
      '/promotions': user.access.promotions,
      '/promotions/:id': user.access.promotions,
      '/examples': user.access.exampleOfWorks,
      '/examples/:id': user.access.exampleOfWorks,
      '/examples/collage/:id': user.access.exampleOfWorks,
      '/doctors': user.access.doctor,
      '/doctors/:id': user.access.doctor,
      '/pointshistory': user.access.scoreHistory,
      '/mailing': user.access.mailing,
      '/reviews': user.access.review,
      '/reviews/:id': user.access.review,
      '/rating': user.access.review,
      '/rating/:id': user.access.review,
      '/patients': user.access.patient,
      '/patients/reports': user.access.patient,
      '/academy': user.access.academy,
      '/academy/course/:id': user.access.academy,
      '/academy/lesson/:id': user.access.academy,
      '/settings': user.access.settings,
    };

    return accessMap[path] || false;
  };

  if (isProtected && !hasAccess()) {
    return <AccessDenied />;
  }

  return <Component {...rest} />;
};

export default AccessRouter;
